import { useContext, useState } from "react"
import { AuthContext, Rotina } from "../../../context/Auth";
import { Agrup, ButtonRotina, Icon, Organize, Seta, SubAgrup } from "../style";
import { ButtonMenu } from "../ButtonMenu";
import { useLocation } from "react-router-dom";
import cadastro from "../../../assets/img/Cadastro.svg";
import seta from "../../../assets/img/seta.svg";

export const MenuCadastro = () => {

  const { usuarioRotinas } = useContext<any>(AuthContext);

  const { pathname } = useLocation();

  const [cadastroclick, setClickcadastro] = useState<boolean>(false);

  const menus = usuarioRotinas.map((rotina: Rotina) => rotina.nomemenu);

  const rotinas = usuarioRotinas.map((rotina: Rotina) => rotina.nomerotina);

  return (
    <>
      {
        menus.some((menu: string) => menu == "Cadastro") ?

          <ButtonRotina className="rotina" onClick={() => { setClickcadastro(!cadastroclick); }}>

            <Organize
              active={pathname?.match('cadastro')}
              aria-label="Menu Cadastro"
            >

              <Agrup>

                <Icon src={cadastro} />

                <p>Cadastro</p>

              </Agrup>

              <Seta src={seta} active={cadastroclick} className="seta" />

            </Organize>

            {cadastroclick ?
              <SubAgrup onClick={(event) => event?.stopPropagation()}>
                {
                  rotinas.some((rotina: string) => rotina == "Grupo de Sede") ?

                    <ButtonMenu direcao="/dash/cadastro/gruposede" nomeEstilo="subitem" titulo="Grupo de Sede" />
                    : false
                }
                {
                  rotinas.some((rotina: string) => rotina == "Sede") ?

                    <ButtonMenu direcao="/dash/cadastro/sede" nomeEstilo="subitem" titulo="Sede" />
                    : false
                }
                {
                  rotinas.some((rotina: string) => rotina == "Ministerio") ?
                    <ButtonMenu titulo="Ministério" direcao="/dash/cadastro/ministerio" nomeEstilo="subitem" />
                    : false
                }
                {
                  rotinas.some((rotina: string) => rotina == "Grupo de Celula") ?
                    <ButtonMenu
                      direcao="/dash/cadastro/grupocelula"
                      nomeEstilo="subitem"
                      titulo="Grupo de Célula" />
                    : false
                }
                {
                  rotinas.some((rotina: string) => rotina == "Grupo de Cargo") ?

                    <ButtonMenu direcao="/dash/cadastro/grupocargo" nomeEstilo="subitem" titulo="Grupo de Cargo" />
                    : false
                }
                {
                  rotinas.some((rotina: string) => rotina == "Cargo") ?

                    <ButtonMenu direcao="/dash/cadastro/cargo" nomeEstilo="subitem" titulo="Cargo" />
                    : false
                }
                {/* {
                  rotinas.some((rotina: string) => rotina == "Cargo do usuario") ?

                    <ButtonMenu direcao="/dash/cadastro/cargomembro" nomeEstilo="subitem" titulo="Cargo do Usuário" />
                    : false
                } */}
                {
                  rotinas.some((rotina: string) => rotina == "Perfil de Membro") ?

                    <ButtonMenu direcao="/dash/cadastro/perfilmembro" nomeEstilo="subitem" titulo="Perfil de Membro" />
                    : false
                }

                {
                  rotinas.some((rotina: string) => rotina == "Atividade") ?
                    <ButtonMenu direcao="/dash/cadastro/atividade" nomeEstilo="subitem" titulo="Atividade" />
                    : false
                }
                {/* {
                  rotinas.some((rotina: string) => rotina == "Permissão") ?
                    <ButtonMenu direcao="/dash/cadastro/permissoes" titulo="Permissões" nomeEstilo="subitem" />
                    : false
                } */}
              </SubAgrup>
              : false}

          </ButtonRotina>
          : false
      }

    </>
  )
}
